import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import HeaderComponent from "../HeaderComponent";
import DynamicViewComponent from "../DynamicViewComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useDataContext } from "../../context/DataProvider";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../api/axios";
import StyledRadioButton from "../StyledRadioButton";
import { useSettingsContext } from "../../context/SettingsProvider";
import { generateSelectMenu } from "../../utility/generateSelectMenu";

import { getIndexOfTodaysDate } from "../../utility/getIndexOfTodaysDate";
import { useTransportUpdateContext } from "../../context/TransportUpdateProvider";
import UpdateLogComponent from "../UpdateLogComponent";
export default function HomePageComponent({ url, header }) {
  const departmentUrl = url || "";
  const auth = useAuth();
  const { setSettingsList, setSelectOptions } = useSettingsContext();
  const axiosPrivate = useAxiosPrivate();
  const { dataList, setDataList } = useDataContext();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const weekIncludesTodaysDate = dataList
    ? getIndexOfTodaysDate(dataList[0]?.shifts) !== -1
      ? getIndexOfTodaysDate(dataList[0]?.shifts)
      : 0
    : 0;
  const [viewStart, setViewStart] = useState(0);
  const [viewEnd, setViewEnd] = useState(3);
  const [viewLength, setViewLength] = useState(4);
  const [interval, setInterval] = useState(1);
  const { updateLog, setUpdateLog } = useTransportUpdateContext();
  const [update, setUpdate] = useState();
  const [sseOn, setSSEOn] = useState(
    localStorage.getItem("eventStream") || false
  );
  const [restartEventStream, setRestartEventStream] = useState(false);
  const applyTextSizes = () => {
    return interval === 6 ? "1em" : interval === 3 ? "1em" : "1em";
  };
  const getLeftOrRightSideOfDisplay = (department) => {
    if (dataList) {
      const sortedArray = dataList.filter((item) =>
        department.includes(item.department)
      );

      return sortedArray;
    }
  };
  const displayLeft = getLeftOrRightSideOfDisplay([
    "*Ansvariga",
    "*Koordinatorer",
    "*Tim Koordinatorer",
    "*Fast Transportörer",
    "*Natt",
    "*Sängcentral",
  ]);
  const displayRight = getLeftOrRightSideOfDisplay(["*Transportörer"]);
  function nextPage(e) {
    e.preventDefault();
    if (viewEnd + interval <= 6) {
      let startValue = viewStart + interval;
      let endValue = viewEnd + interval;
      setViewStart(startValue);
      setViewEnd(endValue);
    }
  }
  function prevPage(e) {
    if (viewStart - interval >= 0) {
      e.preventDefault();
      let startValue = viewStart - interval;
      let endValue = viewEnd - interval;
      setViewStart(startValue);
      setViewEnd(endValue);
    }
  }
  function getDateComponent() {
    const dateArray = dataList[0] || [];

    dateArray.shifts &&
      dateArray.shifts.forEach((week) => {
        week.shifts.forEach((element) => {
          const date = new Date(element.date);
          element.shift = date.getDate();
        });
      });

    return (
      <section>
        <DynamicViewComponent
          includeMonth={true}
          name={""}
          disableEdit={true}
          sixWeekData={dateArray.shifts}
          viewStart={viewStart}
          viewEnd={viewEnd}
          viewLength={viewLength}
          containerHeight={"17px"}
          changeTextSize={() => {
            return interval === 6 ? "1em" : interval === 3 ? ".75em" : "1em";
          }}
        ></DynamicViewComponent>
        {dateArray.shifts && (
          <DynamicViewComponent
            name={"NAMN"}
            disableEdit={true}
            sixWeekData={dateArray.shifts}
            useData={"weekDay"}
            viewStart={viewStart}
            viewEnd={viewEnd}
            viewLength={viewLength}
            containerHeight={"17px"}
            changeTextSize={() => {
              return applyTextSizes();
            }}
          ></DynamicViewComponent>
        )}
      </section>
    );
  }
  function AddDateHeaders(index = 0) {
    const indexArray = [0, 8, 21, 33, 45];
    if (indexArray.includes(index)) {
      return (
        <Fragment key={"subheaders" + index}>
          {getDateComponent(index)}
        </Fragment>
      );
    }
  }

  useEffect(() => {
    const fetchSettingsData = async () => {
      let isMounted = true;
      const controller = new AbortController();

      try {
        const response = await axiosPrivate.get(`${departmentUrl}/settings`, {
          signal: controller.signal,
        });
        isMounted && setSettingsList(response.data);
        setSelectOptions(generateSelectMenu(response.data));
      } catch (err) {
        console.error(err);
      }
      return () => {
        isMounted = false;
        controller.abort();
      };
    };
    fetchSettingsData();
  }, []);

  useEffect(() => {
    if (viewEnd - viewStart === 1) {
      setViewStart(weekIncludesTodaysDate);
      setViewEnd(1 + weekIncludesTodaysDate);
    }
    if (viewEnd - viewStart === 2 && weekIncludesTodaysDate === 5) {
      setViewStart(4);
      setViewEnd(6);
    } else if (viewEnd - viewStart === 2 && weekIncludesTodaysDate !== 5) {
      setViewStart(weekIncludesTodaysDate);
      setViewEnd(weekIncludesTodaysDate + 2);
    }
    if (viewEnd - viewStart === 3 && weekIncludesTodaysDate > 3) {
      setViewStart(3);
      setViewEnd(6);
    } else if (viewEnd - viewStart === 3) {
      setViewStart(weekIncludesTodaysDate);
      setViewEnd(weekIncludesTodaysDate + 3);
    }
  }, [weekIncludesTodaysDate]);

  // const fetchEmployeeData = async () => {
  //   let isMounted = true;
  //   const controller = new AbortController();

  //   try {
  //     setLoading(true);
  //     const response = await axiosPrivate.get(`${departmentUrl}/api`, {
  //       signal: controller.signal,
  //     });
  //     isMounted && setDataList(response.data);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //     setShowErrorMessage(true);
  //   }
  //   return () => {
  //     isMounted = false;
  //     controller.abort();
  //   };
  // };
  useEffect(() => {
    const fetchEmployeeData = async () => {
      let isMounted = true;
      const controller = new AbortController();

      try {
        setLoading(true);
        const response = await axiosPrivate.get(`${departmentUrl}/api`, {
          signal: controller.signal,
        });
        isMounted && setDataList(response.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
        setShowErrorMessage(true);
      }
      return () => {
        isMounted = false;
        controller.abort();
      };
    };
    fetchEmployeeData();
  }, []);

  useEffect(() => {
    const reloadWebpage = () => {
      window.location.reload();
    };
    setTimeout(reloadWebpage, 60000 * 60 * 24 + 10);
  }, []);

  useEffect(() => {
  const ctrl = new AbortController();
  let mounted = true;

  // Ping server every 60s
  const pingCtrl = new AbortController();
  const pingServer = () => {
    axiosPrivate
      .get("/ping", { withCredentials: true, signal: pingCtrl.signal })
      .catch((err) => {
        console.error("Ping failed:", err);
        pingCtrl.abort();
      });
  };

  const pingInterval = setInterval(() => {
    if (mounted) pingServer();
  }, 60000);

  const createEvents = async () => {
    try {
      await fetchEventSource(`${BASE_URL}/${departmentUrl}/sse`, {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
          Authorization: `Bearer ${auth.auth.accessToken}`,
        },
        credentials: "include",
        signal: ctrl.signal,
        heartbeatTimeout: 120000,

        onopen(res) {
          if (res.ok && res.status === 200) {
            console.log("Connection established");
          } else if (res.status === 403) {
            console.warn("Authorization expired");
            ctrl.abort();
          } else if (
            res.status >= 400 &&
            res.status < 500 &&
            res.status !== 429
          ) {
            console.error("Client side error", res);
          }
        },
        onmessage(event) {
          if (mounted && event.event !== "ping" && event.data !== "") {
            const parsedData = JSON.parse(event.data);
            setUpdate(parsedData);
          }
          if (event.event === "ping") {
            console.log("Server ping received");
          }
        },
        onclose() {
          console.log("Connection closed by server");
          if (mounted) {
            setRestartEventStream((prev) => !prev);
          }
        },
        onerror(err) {
          console.error("Error from server", err);
          ctrl.abort();
        },
      });
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("fetchEventSource error:", error);
      }
    }
  };

  if (sseOn) {
    createEvents();
    pingServer();
  }

  return () => {
    mounted = false;
    clearInterval(pingInterval);
    pingCtrl.abort();
    ctrl.abort();
  };
}, [sseOn, restartEventStream]);


  
  useEffect(() => {
    const getUpdates = async () => {
    try {
      await axiosPrivate
        .get(`${url}/api/update`, {
          headers: {
            "Context-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((response) => setUpdateLog(response.data));
    } catch (error) {
      console.error(error);
    }
  };
    getUpdates();
  }, [dataList]);

  useEffect(() => {
    if (update && dataList) {
      const documentIndex = dataList.findIndex(
        (item) => item?._id === update?.documentKey?._id
      );

      const weekIndex = Object.keys(Object.entries(update)[1][1])[0];
      const dataListWeekCopy =
        dataList[documentIndex]?.shifts[weekIndex.slice(-1)]?.shifts;
      const updateWeekCopy = update?.updatedFields[weekIndex]?.shifts;
      const result = dataListWeekCopy?.filter(
        (item, index) => item.shift !== updateWeekCopy[index].shift
      );
      // console.log(dataListWeekCopy, updateWeekCopy);
      const dayIndex = dataListWeekCopy?.findIndex(
        (item) => item?._id === result[0]?._id
      );

      const updatedDataList = [...dataList];
      if (dayIndex !== -1) {
        updatedDataList[documentIndex].shifts[weekIndex.slice(-1)].shifts[
          dayIndex
        ].shift = updateWeekCopy[dayIndex].shift;
        setDataList(updatedDataList);
      }
    }
  }, [update]);

  let currentSubHeader = "";
  function checkSubHeaders(currentSubHeader, department) {
    return currentSubHeader !== department;
  }
  console.log({ aauth: auth });
  return (
    <Container>
      <HeaderComponent
        disableImport={true}
        header={header}
        roles={auth.roles}
        url={departmentUrl}
        eventstream={sseOn}
        addPadding={true}
        setEventStream={setSSEOn}
      ></HeaderComponent>
      <ViewButtonCountainer>
        <NextButton onClick={prevPage}>Före</NextButton>

        <StyledRadioButton
          todaysDate={weekIncludesTodaysDate}
          disable={true}
          setStart={setViewStart}
          setEnd={setViewEnd}
          setLength={setViewLength}
          setInt={setInterval}
        ></StyledRadioButton>
        <NextButton onClick={nextPage}>Nästa</NextButton>
      </ViewButtonCountainer>
      <DisplayGrid>
        <DisplayContainer>
          {dataList && <Fragment key={"initial0"}>{AddDateHeaders()}</Fragment>}
          {dataList &&
            displayLeft.map((item, index) => {
              if (checkSubHeaders(currentSubHeader, item.department)) {
                currentSubHeader = item.department;
                return (
                  <Fragment key={index + 1000}>
                    <SectionHeader key={item.department}>
                      {item.department}
                    </SectionHeader>

                    <DynamicViewComponent
                      disableEdit={true}
                      name={item.name}
                      key={item.name + index}
                      sixWeekData={item.shifts}
                      viewStart={viewStart}
                      viewEnd={viewEnd}
                      viewLength={viewLength}
                      containerHeight={"15px"}
                      changeTextSize={() => {
                        return applyTextSizes();
                      }}
                      url={departmentUrl}
                    ></DynamicViewComponent>
                  </Fragment>
                );
              }
              return (
                <DynamicViewComponent
                  disableEdit={true}
                  name={item.name}
                  key={item.name + index}
                  sixWeekData={item.shifts}
                  viewStart={viewStart}
                  viewEnd={viewEnd}
                  viewLength={viewLength}
                  containerHeight={"15px"}
                  changeTextSize={() => {
                    return applyTextSizes();
                  }}
                  url={departmentUrl}
                ></DynamicViewComponent>
              );
            })}
        </DisplayContainer>
        <DisplayContainer>
          {dataList && <Fragment key={"initial0"}>{AddDateHeaders()}</Fragment>}
          {dataList &&
            displayRight.map((item, index) => {
              if (checkSubHeaders(currentSubHeader, item.department)) {
                currentSubHeader = item.department;
                return (
                  <Fragment key={index + 1000}>
                    <SectionHeader key={item.department}>
                      {item.department}
                    </SectionHeader>
                    <DynamicViewComponent
                      disableEdit={true}
                      name={item.name}
                      key={item.name + index}
                      sixWeekData={item.shifts}
                      viewStart={viewStart}
                      viewEnd={viewEnd}
                      viewLength={viewLength}
                      containerHeight={"15px"}
                      changeTextSize={() => {
                        return applyTextSizes();
                      }}
                      url={departmentUrl}
                    ></DynamicViewComponent>
                  </Fragment>
                );
              }
              return (
                <DynamicViewComponent
                  disableEdit={true}
                  name={item.name}
                  key={item.name + index}
                  sixWeekData={item.shifts}
                  viewStart={viewStart}
                  viewEnd={viewEnd}
                  viewLength={viewLength}
                  containerHeight={"15px"}
                  changeTextSize={() => {
                    return applyTextSizes();
                  }}
                  url={departmentUrl}
                ></DynamicViewComponent>
              );
            })}
          {dataList.length && (
            <UpdateLogComponent context={updateLog} smalltext={"true"} />
          )}
        </DisplayContainer>
      </DisplayGrid>{" "}
      {!loading && !dataList.length && showErrorMessage && (
        <ErrorMessageContainer>
          <h2>Fel inträffat: databasen är tom</h2>
          <p>
            Om du ser detta meddelande är databasen för närvarande tom. Om detta
            har inträffat efter ett försök att ladda upp en excel-fil, är något
            i filen felaktigt implementerat eller startdatumet är inte en
            måndag. Kontrollera uppgifterna i excel-filen igen, bekräfta att
            startdatumet är en måndag och försök igen.
          </p>
        </ErrorMessageContainer>
      )}
    </Container>
  );
}
const ErrorMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  color: black;
  font-weight: 600;
  font-size: 2em;
  flex-direction: column;
  border-radius: 10px;
  margin: 1em;
  padding: 2em;
  background-color: whitesmoke;
`;
const Container = styled.div`
  background-color: #666e79;
  width: auto;
  padding: 0;
  zoom: 50%;
`;
const DisplayContainer = styled.div`
  width: 50%;
  flex: 1;
`;
const DisplayGrid = styled.div`
  display: flex;
  flex-direction: row;
`;
const SectionHeader = styled.div`
  margin-left: 110px;
  @media (max-width: 700px) {
    font-size: 1em;
  }
  text-align: center;
  font-size: 1.5em;
  font-weight: 700;
  color: whitesmoke;
`;

const NextButton = styled.button`
  font-size: 1.2em;
  font-weight: 600;
  min-width: 110px;
  height: 30px;
  @media (min-width: 400px) {
    border: solid 2px;
    width: 10%;
  }
`;
const ViewButtonCountainer = styled.div`
  display: flex;
  justify-content: center;
  width: auto;
  margin: 10px;
  margin-left: 126.5px;
  align-items: center;
  button:hover {
    background-color: green;
    color: white;
    font-size: 1.2em;
  }
  @media (max-width: 700px) {
    margin: 5px 5px;
    button {
      width: 100%;
    }
  }
`;

export function getShiftOptions(settings) {
  const tempArray = [];
  settings.forEach((item, index) => {
    item.shift?.forEach((subItem) => {
      tempArray.push(subItem);
    });
  });
  return tempArray;
}
export function getSelectMenuOptions(settings) {
  const tempArray = [];
  settings.forEach((item, index) => {
    let category = item.category || undefined;
    item.shifts?.forEach((subItem) => {
      tempArray.push(category ? subItem.shift + `#${category}` : subItem.shift);
    });
  });
  return tempArray;
}
